<app-confirmacao-painel-manutencoes [confirmacaoPainelManutencoes]="alertConfirmacao" (confirmacaoPainelManutencoesFechou)="fecharAlertConfirmacao($event)"></app-confirmacao-painel-manutencoes>
<app-loading-generico [loadingGenerico]="loadingDelete"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"></app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

<app-manutencao-toolbar
  [(campoInput)]="campoInput"
  [buscaFiltrada]="buscaFiltrada"
  placeholder="Buscar por CEP ou logradouro arquivo"
  [tagBuscar]="addTagManagerInteraction('box:search:click', 'buscar-por-cep-ou-logradouro-arquivo')"
  [tagLimpar]="addTagManagerInteraction('box:button:click', 'limpar-filtro')"
  (buscar)="buscaFiltradaPorInput()"
  (limpar)="limparFiltro()">
</app-manutencao-toolbar>

@if (enderecos) {
  <table class="table table-hover table-responsive border-bottom">
    <caption>Tabela com a listagem de endereços para manutenção</caption>
    <thead>
      <tr>
        <th scope="col" class="border-top-0">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="selecionaTodosProdutos" (change)="selecionaTodos($event.target)">
            <label class="form-check-label" for="selecionaTodosProdutos"> </label>
          </div>
        </th>
        <th scope="col" class="border-top-0">CEP DO<br>ARQUIVO</th>
        <th scope="col" class="border-top-0">LOGRADOURO<br>DO ARQUIVO</th>
        <th scope="col" class="border-top-0">CEP<br>CORRESPONDENTE</th>
        <th scope="col" class="border-top-0">LOGRADOURO</th>
        <th scope="col" class="border-top-0">NÚMERO</th>
        <th scope="col" class="border-top-0">COMPLEMENTO</th>
        <th scope="col" class="border-top-0">BAIRRO</th>
        <th scope="col" class="border-top-0">CIDADE</th>
        <th scope="col" class="border-top-0">ESTADO</th>
        <th scope="col" class="border-top-0"></th>
      </tr>
    </thead>
    <tbody>
      @for (endereco of enderecos.data; track endereco) {
        <tr>
          <td class="pt-2">
            <div class="form-check">
              <input type="checkbox" class="form-check-input"
                id="{{endereco.codigoCepArquivo}}"
                name="inputsEnderecos"
                [attr.aria-label]="endereco.codigoCepArquivo + ':' + endereco.endereco.codigoCep"
                [tag]="addTagManagerInteraction('select:checkbox:click', endereco.codigoCepArquivo+':'+endereco.endereco.codigoCep)">
              <label class="form-check-label" for="{{endereco.codigoCepArquivo}}"></label>
            </div>
          </td>
          <td class="coluna-destaque text-nowrap">{{endereco.codigoCepArquivo}}</td>
          <td class="coluna-destaque">{{endereco.descricaoLogradouroArquivo}}</td>
          <td>{{endereco.endereco.codigoCep}}</td>
          <td>{{endereco.endereco.descricaoLogradouro}}</td>
          <td>{{endereco.endereco.codigoNumero}}</td>
          <td>{{endereco.endereco.codigoComplemento}}</td>
          <td>{{endereco.endereco.codigoBairro}}</td>
          <td>{{endereco.endereco.codigoCidade}}</td>
          <td>{{endereco.endereco.codigoEstado}}</td>
          <td>
            <button
              (click)="showAlertConfirmacao('excluirUnico', endereco.codigoCepArquivo)"
              (keydown.enter)="showAlertConfirmacao('excluirUnico', endereco.codigoCepArquivo)"
              [tag]="addTagManagerInteraction('select:icon:click', endereco.codigoCepArquivo+':'+endereco.endereco.codigoCep+'-excluir')"
              class="btn-icon">
              <i class="fa fa-trash c-primary" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (enderecos) {
  <div class="w-100 text-center">
    <button class="botaoLongo mt-4" (click)="showAlertConfirmacao('excluirSelecionados', '')">EXCLUIR SELECIONADOS</button>
  </div>
}

<app-manutencao-footer
  [dados]="enderecos"
  [tamanho]="tamanho"
  [pagina]="pagina"
  [itensPaginacao]="itensPaginacao"
  [tagDropdown]="addTagManagerInteraction('select:dropdown:click', 'exibir-por-pagina')"
  [tagPagina]="addTagManagerInteraction('select:number:click', 'escolher-proxima-pagina')"
  (tamanhoChange)="tamanho = $event"
  (alterarTamanho)="alteraQuantidadePorPagina()"
  (alterarPagina)="alteraPagina($event)">
</app-manutencao-footer>

<app-lista-estado
  [dados]="enderecos"
  mensagemCarregando="Consultando endereços ..."
  mensagemErro="Ocorreu um erro na consulta de endereços."
  mensagemVazio="Não existem endereços para essa consulta.">
</app-lista-estado>
